// Lightweight analytics helper — fires events to Google Analytics (gtag) and Meta Pixel (fbq).
// IDs are read from build-time env vars REACT_APP_GA_ID and REACT_APP_META_PIXEL_ID.
// If IDs are not set, init() is a no-op and all track() calls silently skip.

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  const GA_ID = process.env.REACT_APP_GA_ID;
  const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

  // ----- Google Analytics 4 (gtag) -----
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: true });
  }

  // ----- Meta Pixel (fbq) -----
  if (PIXEL_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

/**
 * Fire a tracked event to both GA and Meta Pixel (whichever is loaded).
 * @param {string} name - canonical event name (lead, purchase, view_course, etc.)
 * @param {object} params - { value, currency, course_id, course_title, ... }
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    if (window.gtag) window.gtag("event", name, params);
  } catch (_) { /* no-op */ }
  try {
    if (window.fbq) {
      const FB_STANDARD = {
        lead: "Lead",
        purchase: "Purchase",
        view_course: "ViewContent",
        begin_checkout: "InitiateCheckout",
        add_to_cart: "AddToCart",
        complete_registration: "CompleteRegistration",
      };
      const standard = FB_STANDARD[name];
      if (standard) window.fbq("track", standard, params);
      else window.fbq("trackCustom", name, params);
    }
  } catch (_) { /* no-op */ }
}

export const Analytics = {
  lead: (params) => trackEvent("lead", params),
  purchase: (params) => trackEvent("purchase", params),
  viewCourse: (params) => trackEvent("view_course", params),
  beginCheckout: (params) => trackEvent("begin_checkout", params),
};
